import { handleAxiosError } from '@/@core/axios/handleError'
import { useAuthStore } from '@/stores/auth'
import { camelizeKeys } from 'humps'

import axios from 'axios'
import jwtDefaultConfig from '@core/auth/jwt/jwtDefaultConfig'

const { VITE_APP_URL } = import.meta.env

const axiosInstance = axios.create({
  baseURL: VITE_APP_URL + '/api',
})

const tokenType = jwtDefaultConfig.tokenType

axiosInstance.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem(
      jwtDefaultConfig.storageTokenKeyName
    )

    if (accessToken)
      config.headers.Authorization = `${tokenType} ${accessToken}`

    return config
  },
  (error) => Promise.reject(error)
)

axiosInstance.interceptors.response.use(
  (response) => {
    if (
      response.data &&
      response.headers['content-type'] === 'application/json'
    ) {
      response.data = camelizeKeys(response.data)
    }

    return response
  },
  async (error) => {
    const originalRequest = error?.config
    const statusCode = error?.response?.status
    const authRequest = originalRequest.url === '/auth/login'
    const refreshRequest = originalRequest.url === '/auth/refresh'

    if (refreshRequest && statusCode === 401) {
      // window.location.href = '/'

      return Promise.reject(error)
    }

    if (authRequest && statusCode === 401) {
      // window.location.href = '/'

      return Promise.reject(error)
    }

    const responseError = {
      error: handleAxiosError(error),
      statusCode,
    }

    if (statusCode === 401 && !originalRequest._retry) {
      originalRequest._retry = true

      const authStore = useAuthStore()
      const token = await authStore.getRefreshToken()

      axios.defaults.headers.common['Authorization'] = `${tokenType} ${token}`

      return axiosInstance(originalRequest)
    }

    return Promise.reject(responseError)
  }
)

export default axiosInstance
